export const PROFILE_SET_DATA = 'PROFILE_SET_DATA';

export const MOMENT_SET_DATA = 'MOMENT_SET_DATA';

export const FEEDBACK_SET = 'FEEDBACK_SET';
export const FEEDBACK_HIDE = 'FEEDBACK_HIDE';
export const FEEDBACK_SET_EXPLORE = 'FEEDBACK_SET_EXPLORE';